export { default as Toggle } from 'employees/components/list/actions/EmployeesActionsToggle';
export { default as Edit } from 'employees/components/list/actions/EmployeesActionsEdit';



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/actions/index.js